import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { OrdemCompraDropDown } from "../../../../../../common/domain/models/ordem_compra_dropdown";
import { SubcontaDropdown } from "../../../../../rh/domain/models/subconta_dropdown";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";
import { ProdutoServicoDropDown } from "../../../../../../common/domain/models/produto_servico_dropdown";
import { useMemo } from "react";
import { ReportComprasForm, ReportComprasSchema } from "../../../schemas/OrdemCompra_consultarPrecos/report_compras";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ComprasReportModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  centroCustoDropdown: CentroCustoDropDown[];
  ordemComprasDropdown: OrdemCompraDropDown[];
  subcontasDropdown: SubcontaDropdown[];
  fornecedoresDropdown: FornecedorDropDown[];
  produtoServicosDropdown: ProdutoServicoDropDown[];
  onClose: () => void;
  onSubmit: (form: ReportComprasForm) => void;
}

export const ComprasReportModal = ({
  open,
  saving,
  loading,
  centroCustoDropdown,
  ordemComprasDropdown,
  subcontasDropdown,
  fornecedoresDropdown,
  produtoServicosDropdown,
  onClose,
  onSubmit,
}: Props) => {

  const statusOCOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Entregues',
      },
      {
        id: 2,
        label: 'Canceladas',
      },
    ];
  }, [
  ]);

  const hookForm = useForm<ReportComprasForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ReportComprasSchema),
  });

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Relatório de Compras"
      confirmButtonLabel="Gerar Relatório"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="flex flex-col gap-4 py-4">
        <DefaultFormMultiAutocomplete
          name='centroCustos'
          label='Centro de Custo'
          options={centroCustoDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='titulo'
          label='Título'
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='ordemCompras'
          label='Ordem de Compra'
          options={ordemComprasDropdown}
          getOptionKey={x => x.idOrdemCompra}
          getOptionLabel={x => x.descricao}
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='subcontas'
          label='Subconta'
          options={subcontasDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='fornecedores'
          label='Fornecedor'
          options={fornecedoresDropdown}
          getOptionKey={x => x.idFornecedor}
          getOptionLabel={x => x.nomeFantasia}
          reactHookForm={hookForm}
        />

        <FormRangeDatePickerInput
          name='dataOC'
          label='Data OC'
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='produtoServicos'
          label='Produto/Serviço'
          options={produtoServicosDropdown}
          getOptionKey={x => x.idProdutoServico}
          getOptionLabel={x => x.descricao}
          reactHookForm={hookForm}
        />

        <FormRangeDatePickerInput
          name='dataPago'
          label='Data Pago'
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='statusOC'
          label='Status OC'
          options={statusOCOptions}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.label}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}